import type {T} from '@aiw/i18n';
export function scheduleError(message:string,t:T):string {
 if(message.includes('Job and installation reference different accepted quotes'))return t('schedule.quoteLocksConflict');
 if(message.includes('accepted quote is unavailable'))return t('schedule.quoteUnavailable');
 if(message.includes('More than one primary quote'))return t('schedule.quoteAmbiguous');
 if(message.includes('More than one installation is recorded'))return t('schedule.installAmbiguous');
 if(message.includes('Choose a primary quote before scheduling'))return t('schedule.quoteRequired');
 return message;
}
